import { Address } from 'viem'

import * as ALL_CHAINS from '@/constants/chains/master'

export interface ChainIdAddressMapping {
  [ChainId: number]: Address
}

export const MINICHEF_ADDRESSES: ChainIdAddressMapping = {
  [ALL_CHAINS.BNB.id]: `0x8F5BBB2BB8c2Ee94639E55d5F41de9b4839C1280`,
  [ALL_CHAINS.ETH.id]: `0xd10eF2A513cEE0Db54E959eF16cAc711470B62cF`,
  [ALL_CHAINS.POLYGON.id]: `0x7875Af1a6878bdA1C129a4e2356A3fD040418Be5`,
  [ALL_CHAINS.FANTOM.id]: `0xaeD5b25BE1c3163c907a471082640450F928DDFE`,
  [ALL_CHAINS.ARBITRUM.id]: `0x73186f2Cf2493f20836b17b21ae79fc12934E207`,
  [ALL_CHAINS.AVALANCHE.id]: `0x3a01521F8E7F012eB37eAAf1cb9490a5d9e18249`,
  [ALL_CHAINS.HARMONY.id]: `0xaeD5b25BE1c3163c907a471082640450F928DDFE`,
  [ALL_CHAINS.BOBA.id]: `0xd5609cD0e1675331E4Fb1d43207C8d9D83AAb17C`,
  [ALL_CHAINS.OPTIMISM.id]: `0xe8c610fcb63A4974F02Da52f0B4523937012Aaa0`,
  [ALL_CHAINS.AURORA.id]: `0x809DC529f07651bD43A172e8dB6f4a7a0d771036`,
  [ALL_CHAINS.METIS.id]: `0xaB0D8Fc46249DaAcd5cB36c5F0bC4f0DAF34EBf5`,
  [ALL_CHAINS.KLAYTN.id]: `0xF68cD56cF9a9e1cDa181fb2C44C5F0E98B5cC541`,
  [ALL_CHAINS.DOGE.id]: `0x995Abc3EEf2894E8923E1d58e5E62f2BCF90cd4E`,
  [ALL_CHAINS.CANTO.id]: `0x93124c923dA389Bc0f13840fB822Ce715ca67ED6`,
  [ALL_CHAINS.BASE.id]: `0xfFC2d603fde1F99ad94026c00B6204Bb9b8c36E9`,
  [ALL_CHAINS.BLAST.id]: `0x3100dC8464A8523306c3C5034de24a8927d6E590`,
}
